import { Driver } from "./types";

export const mockDrivers: Driver[] = [
  {
    id: "1",
    firstName: "Marcus",
    lastName: "Johnson",
    vendor: "Standard Fleet Operations",
    externalId: "M9143-00009-80227",
    phoneNumber: "+1 (305) 555-0179",
    ratings: 4,
    state: "Offline",
    labels: ["Florida", "Miami", "South Beach"],
    address: "1717 Ocean Drive, Miami Beach, FL"
  },
  {
    id: "2",
    firstName: "David",
    lastName: "Martinez",
    vendor: "Standard Fleet Operations",
    externalId: "MART1405",
    phoneNumber: "+1 (512) 555-7014",
    ratings: 5,
    state: "Offline",
    labels: ["Texas", "Austin"]
  },
  {
    id: "3",
    firstName: "Robert",
    lastName: "Williams",
    vendor: "Standard Fleet Operations",
    externalId: "B3711-7970",
    phoneNumber: "+1 (602) 555-6605",
    ratings: 4,
    state: "Offline",
    labels: ["Arizona", "Phoenix"]
  },
  {
    id: "4",
    firstName: "James",
    lastName: "Brown",
    vendor: "Standard Fleet Operations",
    externalId: "3412274",
    phoneNumber: "+1 (206) 555-7976",
    ratings: 5,
    state: "Driving",
    labels: ["Washington", "Seattle"]
  },
  {
    id: "5",
    firstName: "Michael",
    lastName: "Davis",
    vendor: "Standard Fleet Operations",
    externalId: "1475475",
    phoneNumber: "+1 (617) 555-2310",
    ratings: 4,
    state: "Stand-by",
    labels: ["Massachusetts", "Boston"]
  },
  {
    id: "6",
    firstName: "Thomas",
    lastName: "Miller",
    vendor: "Express Transit Services",
    externalId: "3367039",
    phoneNumber: "+1 (303) 555-9746",
    ratings: 4,
    state: "Stand-by",
    labels: ["Colorado", "Denver"]
  },
  {
    id: "7",
    firstName: "Christopher",
    lastName: "Wilson",
    vendor: "Standard Fleet Operations",
    externalId: "WILS1503",
    phoneNumber: "+1 (619) 555-2683",
    ratings: 5,
    state: "Stand-by",
    labels: ["California", "San Diego"]
  },
  {
    id: "8",
    firstName: "Daniel",
    lastName: "Moore",
    vendor: "Standard Fleet Operations",
    externalId: "1426637",
    phoneNumber: "+1 (415) 555-1693",
    ratings: 4,
    state: "Offline",
    labels: ["California", "San Francisco"]
  },
  {
    id: "9",
    firstName: "Matthew",
    lastName: "Taylor",
    vendor: "Standard Fleet Operations",
    externalId: "T4001-7960",
    phoneNumber: "+1 (615) 555-2873",
    ratings: 4,
    state: "Stand-by",
    labels: ["Tennessee", "Nashville"]
  },
  {
    id: "10",
    firstName: "Anthony",
    lastName: "Anderson",
    vendor: "Standard Fleet Operations",
    externalId: "3168122",
    phoneNumber: "+1 (404) 555-1555",
    ratings: 5,
    state: "Offline",
    labels: ["Georgia", "Atlanta"]
  }
];